import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth.jsx';
import { useT } from './lib/i18n.jsx';
import Shell from './components/Shell.jsx';
import Login from './pages/Login.jsx';
import Overview from './pages/Overview.jsx';
import Kids from './pages/Kids.jsx';
import Subscription from './pages/Subscription.jsx';
import Account from './pages/Account.jsx';

/** Full-page spinner for the window between "we have a token" and "we have a user". */
function Booting() {
  const t = useT();
  return (
    <div className="boot">
      <div className="spinner" aria-hidden="true" />
      <p>{t('common.loading')}</p>
    </div>
  );
}

function RequireAuth({ children }) {
  const { isAuthed, loading, user } = useAuth();
  const location = useLocation();

  if (!isAuthed) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  // A stored token with no user yet means the first snapshot is still in
  // flight — render the shell only once there is something to put in it.
  if (loading && !user) return <Booting />;

  return children;
}

export default function App() {
  const { isAuthed } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthed ? <Navigate to="/" replace /> : <Login />} />
      <Route
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      >
        <Route index element={<Overview />} />
        <Route path="kids" element={<Kids />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="account" element={<Account />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
